module.exports = "<symbol id=\"tt-icon-options-collapse\" viewBox=\"0 0 24 24\"><path d=\"M5.47 0L3.69 1.66 12 9.5l8.31-7.84L18.53 0 12 6.17 5.47 0zM12 17.82L18.53 24l1.78-1.66L12 14.5l-8.31 7.84L5.47 24 12 17.82z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"


//////////////////
// WEBPACK FOOTER
// ./src/build/KmHgiPlfcrGbDfYsite/assets/svg/pdp-page/options-collapse.svg
// module id = 212
// module chunks = 9